module.exports = __webpack_public_path__ + "img/remove-dash.65978a49.svg";